import { Component, OnDestroy, OnInit } from '@angular/core';
import { currentYear } from '@shared/helpers/helpers';
import { TranslateService } from '@ngx-translate/core';
import { distinct, distinctUntilChanged, Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
    protected currentYear = currentYear;
    protected footerEN: IFooter = {
        corporateInformation: 'https://www.siemens.com/corporate-information',
        privacyNotice: 'https://new.siemens.com/global/en/general/privacy-notice.html',
        intranetPrivacyNotice: 'https://intranet.siemens.com/data-privacy',
        termsOfUse: 'https://www.siemens.com/terms-of-use',
        digitalId: 'https://www.siemens.com/digital-id',
        cookieNotice: 'https://www.siemens.com/cookie-notice',
        whistleblowing: 'https://www.siemens.com/whistleblowing',
        gms: 'https://gms.siemens.cloud/'
    };
    protected footerDE: IFooter = {
        corporateInformation: 'https://www.siemens.de/impressum',
        privacyNotice: 'https://www.siemens.de/datenschutz',
        intranetPrivacyNotice: 'https://intranet.siemens.de/datenschutz ',
        termsOfUse: 'https://www.siemens.de/nutzungsbedingungen',
        digitalId: 'https://www.siemens.com/digital-id',
        cookieNotice: 'https://www.siemens.de/cookie-policy',
        whistleblowing: 'https://www.siemens.de/whistleblowing',
        gms: 'https://gms.siemens.cloud/'
    };

    get footer(): IFooter {
        return this._footer;
    }

    private _footer = this.footerEN;
    private destroy$ = new Subject<boolean>();

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.listenToLanguageChange();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    private listenToLanguageChange(): void {
        this.translateService.onLangChange
            .pipe(
                takeUntil(this.destroy$),
                distinctUntilChanged(),
                tap(event => {
                    if (event.lang === 'de') {
                        this._footer = this.footerDE;
                    } else {
                        this._footer = this.footerEN;
                    }
                })
            )
            .subscribe();
    }
}

interface IFooter {
    corporateInformation: string;
    privacyNotice: string;
    intranetPrivacyNotice: string;
    termsOfUse: string;
    digitalId: string;
    cookieNotice: string;
    whistleblowing: string;
    gms: string;
}
